import * as _4 from 'lodash4';
import { ICommand, IQuery } from 'core-ts-types';
import { ITimeSliceTile } from '../../interfaces/scheduler_interfaces';
import { SectionInfoServant } from '../../views/sections/servants/section_info_servant';

class TimeSliceTilesController {
  private timeSlices: ITimeSliceTile[];
  private currentlySelectedDate: ITimeSliceTile;
  private visibleSegments: string = '';
  private showLabelWithCount: boolean = false;
  private selectedDateRangeLabel: string = '';

  constructor(private saveSelectedTimeSliceToModel: ICommand, private ngSectionInfoServant: SectionInfoServant) {}

  init() {
    this.currentlySelectedDate = this.timeSlices[0];
    this.selectFirstValidTab();
  }

  $onInit() {
    this.init();
  }
  $onChanges() {
    this.updateSelectedIndex();
  }

  updateSelectedIndex() {
    this.currentlySelectedDate = _4.find(this.timeSlices, { isActive: true });
    this.getDisplayDate();
  }

  getDisplayDate() {
    if (!this.currentlySelectedDate) {
      return;
    }
    const sliceStart = this.currentlySelectedDate.timeSliceStartDate;
    const sliceEnd = this.currentlySelectedDate.timeSliceEndDate;

    if (sliceStart && sliceEnd) {
      this.selectedDateRangeLabel = this.ngSectionInfoServant.convertDateToRange(
        sliceStart.format('YYYY-MM-DD'),
        sliceEnd.format('YYYY-MM-DD'),
        'MMMM DD',
        'MMMM DD, YYYY'
      );
    }
  }
  selectFirstValidTab() {
    const firstActiveSlice = this.timeSlices[0];
    this.saveSelectedTimeSliceToModel(firstActiveSlice);
  }

  emptyDate(selectedDate: string) {
    return selectedDate === '';
  }

  setTimeSlice(timeSlice: ITimeSliceTile) {
    if (timeSlice) {
      this.currentlySelectedDate = timeSlice;
      this.updateSelectedTimeSliceModal(timeSlice);
    }
  }

  prevTimeSlice() {
    const currentIndex = this.findCurrentTimesliceIndex();
    const prevTimeSlice = this.timeSlices[currentIndex - 1];
    this.setTimeSlice(prevTimeSlice);
  }

  nextTimeSlice() {
    const currentIndex = this.findCurrentTimesliceIndex();
    const nextTimeSlice = this.timeSlices[currentIndex + 1];
    this.setTimeSlice(nextTimeSlice);
  }

  findCurrentTimesliceIndex() {
    return _4.findIndex(
      this.timeSlices,
      _4.find(this.timeSlices, (slice: ITimeSliceTile) => slice.startUnix === this.currentlySelectedDate.startUnix)
    );
  }

  updateSelectedTimeSliceModal(timeSlice: ITimeSliceTile) {
    this.saveSelectedTimeSliceToModel(timeSlice);
  }
}

angular.module('capability-ng-scheduler').component('timeSliceTiles', {
  templateUrl: 'capability-ng-scheduler/src/components/time_slice_tiles/time_slice_tiles.html',
  bindings: {
    timeSlices: '<'
  },
  controller: TimeSliceTilesController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/time_slice_tiles/time_slice_tiles.ts